import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "oge.cookie-consent";

export function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const compact = useMediaQuery("(max-width: 520px)");

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setVisible(true);
    } catch {/* SSR / privacy mode */}
  }, []);

  function accept(value) {
    try { localStorage.setItem(KEY, value); } catch {}
    setVisible(false);
  }

  if (!visible) return null;

  const ghostStyle = {
    ...btnGhost,
    width: compact ? "100%" : undefined,
  };
  const primaryStyle = {
    ...btnPrimary,
    width: compact ? "100%" : undefined,
  };

  return (
    <div role="dialog" aria-label="Cookie preferences" style={{
      position: "fixed",
      left: compact ? 10 : 16,
      right: compact ? 10 : 16,
      bottom: `calc(env(safe-area-inset-bottom) + ${compact ? 10 : 16}px)`,
      maxWidth: compact ? "calc(100vw - 20px)" : 720,
      margin: "0 auto",
      background: "var(--bg-elevated)", color: "var(--text)",
      borderRadius: 16, border: "1px solid var(--border)",
      boxShadow: "var(--shadow-lg)",
      padding: compact ? 12 : "14px 18px",
      display: "flex",
      flexDirection: compact ? "column" : "row",
      justifyContent: "space-between",
      gap: compact ? 10 : 14,
      alignItems: compact ? "stretch" : "center",
      flexWrap: "wrap",
      zIndex: 200,
      maxHeight: "calc(100svh - 24px)",
      overflowY: "auto",
    }}>
      <div style={{ flex: 1, minWidth: 0, fontSize: compact ? 12.5 : 13, lineHeight: 1.5 }}>
        We store a small preference flag and your theme in localStorage so the site remembers you. No advertising trackers.
        See our <Link to="/legal/privacy" style={{ color: "var(--accent)", fontWeight: 600 }}>Privacy Policy</Link>.
      </div>
      <div style={{
        display: compact ? "grid" : "flex",
        gridTemplateColumns: compact ? "1fr 1fr" : undefined,
        gap: 8,
        width: compact ? "100%" : undefined,
      }}>
        <button onClick={() => accept("necessary")} style={ghostStyle}>Necessary only</button>
        <button onClick={() => accept("all")}        style={primaryStyle}>Accept all</button>
      </div>
    </div>
  );
}

function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => (
    typeof window !== "undefined" ? window.matchMedia(query).matches : false
  ));

  useEffect(() => {
    if (typeof window === "undefined") return;
    const mql = window.matchMedia(query);
    const onChange = (event) => setMatches(event.matches);
    setMatches(mql.matches);
    if (mql.addEventListener) {
      mql.addEventListener("change", onChange);
      return () => mql.removeEventListener("change", onChange);
    }
    mql.addListener?.(onChange);
    return () => {
      mql.removeListener?.(onChange);
    };
  }, [query]);

  return matches;
}

const btnGhost = {
  padding: "8px 14px", borderRadius: 999, fontSize: 12, fontWeight: 600, cursor: "pointer",
  minHeight: 44,
  background: "transparent", color: "var(--text)",
  border: "1.5px solid var(--border-strong)",
};
const btnPrimary = {
  ...btnGhost, color: "#fff", border: "none",
  background: "linear-gradient(135deg, var(--mauve), var(--mauve-deep))",
};
